<div *ngIf="translatedNoteRows" class="notice">
    <p *ngFor="let noteRow of translatedNoteRows" class="notice-row">
        {{ noteRow }}
    </p>
</div>
